export const CONSONANT_VOWEL_PAIRS_N = [

    // ㄴ
    {
        id: 1,
        korean: "나",
        english: "na",

    },
    {
        id: 2,
        korean: "네",
        english: "ne",

    },
    {
        id: 3,
        korean: "니",
        english: "ni",

    },
    {
        id: 4,
        korean: "노",
        english: "no",

    },
    {
        id: 5,
        korean: "느",
        english: "neu",

    },
    {
        id: 6,
        korean: "너",
        english: "neo",

    },
    {
        id: 7,
        korean: "냐",
        english: "nya",

    },
    {
        id: 8,
        korean: "내",
        english: "nae",

    },
    {
        id: 9,
        korean: "녜",
        english: "nye",

    },
    {
        id: 10,
        korean: "뇨",
        english: "nyo",

    },
    {
        id: 11,
        korean: "녀",
        english: "nyeo",

    },
    {
        id: 12,
        korean: "뉴",
        english: "nyu",

        

    },

    {
        id: 13,
        korean: "난",
        english: "nan",

        

    },
    {
        id: 14,
        korean: "낙",
        english: "nak",

        

    },
    {
        id: 15,
        korean: "님",
        english: "nim",
        

    },
    {
        id: 16,
        korean: "낫",
        english: "nat",
        

    },
    {
        id: 17,
        korean: "낳",
        english: "nah",
        

    },
    {
        id: 18,
        korean: "넙",
        english: "neob",
        

    },
          {
        id: 19,
        korean: "늘",
        english: "neul",
        

    },
    {
        id: 20,
        korean: "낮",
        english: "nat",
        

    },
    {
        id: 21,
        korean: "낶",
        english: "naekk",
        

    },
    {
        id: 22,
        korean: "낸",
        english: "naen",
        

    },
    {
        id: 23,
        korean: "늬",
        english: "nui",
        

    },
    {
        id: 24,
        korean: "눠",
        english: "nwo",
        

    },

    {
        id: 25,
        korean: "냩",
        english: "nyat",
        

    },
    {
        id: 26,
        korean: "닏",
        english: "nat",
        

    },
    {
        id: 27,
        korean: "낭",
        english: "nang",
        
    }
    
];

